import { parseBplist } from './bplist.js';
import { UnwrapError } from './mhtml.js';

export function webarchiveToHtml(bytes: Uint8Array): string {
  const root = parseBplist(bytes) as Record<string, unknown> | null;
  const main = root?.['WebMainResource'] as Record<string, unknown> | undefined;
  const data = main?.['WebResourceData'];
  // instanceof yerine isView: jsdom/test ortamlarında farklı realm'lerin Uint8Array'i eşleşmeyebilir
  if (!ArrayBuffer.isView(data)) throw new UnwrapError('NO_MAIN_RESOURCE', 'WebArchive içinde ana kaynak yok');
  const encName = typeof main?.['WebResourceTextEncodingName'] === 'string' ? (main['WebResourceTextEncodingName'] as string) : 'utf-8';
  let decoder: TextDecoder;
  try { decoder = new TextDecoder(encName); } catch { decoder = new TextDecoder('utf-8'); }
  return decoder.decode(data);
}
